// extracted by mini-css-extract-plugin
export default {"main":"MainBlock_main__8Ndp5","main_wrap":"MainBlock_main_wrap__aKmbJ","main_title":"MainBlock_main_title__yO775","main_desc":"MainBlock_main_desc__OzFww"};